<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getRestaurantTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionRestaurant && permissionRestaurant.permission_id === permission.readWrite"
          @click.native="createRestaurant" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>
                <div v-html="item.description_th"></div>
              </td>
              <td>
                <div v-html="item.description_en"></div>
              </td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showRestaurantData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
import {permissionRestaurant, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Swal from 'sweetalert';
import Loading from 'vue-loading-overlay';

export default {
  name: "RestaurantTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch, Loading },
  data() {
    return {
      title: "Restaurant",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,'icon' : null},
        { id: 2, text: "Branch" ,'icon' : null},
        { id: 3, text: "Description TH" ,'icon' : null},
        { id: 4, text: "Description EN" ,'icon' : null},
        { id: 5, text: "Update date" ,'icon' : true},
        { id: 6, text: "edit" ,'icon' : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_date : 'desc',
      sort : 'desc',
    };
  },

  created() {
    this.permission = role;
    this.getRestaurantTable(1);
  },
  computed: {
    permissionRestaurant,
  },
  methods: {
    goToRestaurantEdit() {
      this.$router.push("/restaurant/edit");
    },
    getRestaurantTable(page) {
      this.isLoading = true;
      this.$store.dispatch("Restaurant/getRestaurant", {
        page,
        search : this.search,
        sort_date : this.sort_date,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getRestaurantTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    showRestaurantData(id) {
      this.isLoading = true;
      this.$store.dispatch("Restaurant/showRestaurant", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Restaurant/setFormRestaurant", res.result).then(() => {
            this.goToRestaurantEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createRestaurant() {
      this.$store.dispatch("Restaurant/clearFormData").then(() => {
        this.goToRestaurantEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      console.log(this.sort);
      this.getRestaurantTable(1);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables.scss";

.branch-data {
  background-color: $background-theme;
  margin: $margin-search;
}
</style>
